// Generic device type detector (inspired by react-device-detect)

export default () => {
  if (typeof navigator === "undefined") return "desktop"; // SSR safety

  const ua = navigator.userAgent;
  const width = window.innerWidth;

  // ---- Mobile detection ----
  const isMobile = /Mobi|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

  // ---- Tablet detection ----
  const isTablet =
    /Tablet|iPad|PlayBook|Silk/i.test(ua) || (/(Android)/i.test(ua) && !/Mobi/i.test(ua));

  // ---- iPadOS 13+ fix (reports as Mac) ----
  const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

  // ---- Width fallback ----
  const isTabletWidth = width >= 768 && width <= 1024;
  const isMobileWidth = width < 768;

  // ---- Final classification ----
  if (isTablet || isIPadOS || isTabletWidth) return "tablet";

  if (isMobile || isMobileWidth) return "mobile";

  return "desktop";
};
